export default {
    imageAIFormRules: {
        enterDescription: 'Vul de beschrijving in aub',
        invalidDescription: 'Vul een geldige beschrijving in aub',
        enterNumberOfVariations: 'Selecteer het aantal variaties aub',
        invalidNumberOfVariations: 'You can generate maximum 4 and minimum 1 variation',
        enterStyle: 'Please select at least one style',
    },
};
